import { render, staticRenderFns } from "./PanelWithWithdrawCreate.vue?vue&type=template&id=e2b276ea&lang=pug&"
import script from "./PanelWithWithdrawCreate.vue?vue&type=script&lang=ts&"
export * from "./PanelWithWithdrawCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithWithdrawCreate.vue?vue&type=style&index=0&id=e2b276ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports